/** @deprecated use specific roles instead */
export const ADMIN = 'ADMIN'
/** @deprecated use specific roles instead */
export const DATA_EXPORTER = 'DATA_EXPORTER'

export const ENTITLEMENT_READ = 'entitlement.read'
export const ENTITLEMENT_WRITE = 'entitlement.write'
export const ENTITLEMENT_ADMIN = 'entitlement.admin'

export const DEVICE_READ = 'device.read'
export const DEVICE_WRITE = 'device.write'
export const DEVICE_ADMIN = 'device.admin'
export const DEVICE_OPERATE = 'device.operate'
export const DEVICE_MAINTAIN = 'device.maintain'
export const DEVICE_EXEMPT = 'device.exempt'

export const COMPANY_READ = 'company.read'
export const COMPANY_WRITE = 'company.write'
export const COMPANY_ADMIN = 'company.admin'

export const ORGANIZATION_READ = 'organization.read'
export const ORGANIZATION_ADMIN = 'organization.admin'
export const ORGANIZATION_SUBSIDIARY = 'organization.subsidiary'

export const SITE_READ = 'site.read'
export const SITE_WRITE = 'site.write'
export const SITE_ADMIN = 'site.admin'

export const SYSTEM_READ = 'system.read'
export const SYSTEM_WRITE = 'system.write'
export const SYSTEM_ADMIN = 'system.admin'
export const SYSTEM_OPERATION = 'system.operate'

export const SHARING_READ = 'share.read'
export const SHARING_WRITE = 'share.write'
export const SHARING_ADMIN = 'share.admin'

export const REGISTRATION_CREATE = 'registration.create'

export const DOCUMENT_READ = 'document.read'
export const DOCUMENT_WRITE = 'document.write'

export const IMAGE_READ = 'image.read'
export const IMAGE_WRITE = 'image.write'

export const NOTE_READ = 'note.read'
export const NOTE_WRITE = 'note.write'

export const ACCOUNTING_ACCOUNT_ADMIN = 'accounting.account.admin'
export const ACCOUNTING_ACCOUNT_READ = 'accounting.account.read'
export const ACCOUNTING_ACCOUNT_WRITE = 'accounting.account.write'

export const ACCOUNTING_CHARGE_ADMIN = 'accounting.charge.admin'
export const ACCOUNTING_CHARGE_READ = 'accounting.charge.read'

export const ACCOUNTING_LICENSE_ADMIN = 'accounting.license.admin'
export const ACCOUNTING_LICENSE_READ = 'accounting.license.read'

export const ACCOUNTING_MODEL_ADMIN = 'accounting.model.admin'
export const ACCOUNTING_MODEL_READ = 'accounting.model.read'

export const ACCOUNTING_PERMISSION_ADMIN = 'accounting.permission.admin'
export const ACCOUNTING_VOUCHER_ADMIN = 'accounting.voucher.admin'

export const PROCESS_READ = 'process.read'
export const PROCESS_WRITE = 'process.write'
export const PROCESS_ADMIN = 'process.admin'

export const BETA_ACCESS = 'beta.access'
export const PUBLIC_ACCESS = 'public'

export const COMMERCE_READ = 'commerce.read'
export const COMMERCE_WRITE = 'commerce.write'
export const COMMERCE_PRICE = 'commerce.price'
export const COMMERCE_ORDER = 'commerce.order'
export const COMMERCE_ADMIN = 'commerce.admin'

export const CERTIFICATE_READ = 'certificate.read'
export const CERTIFICATE_ADMIN = 'certificate.admin'

export const ACCOUNTING_ADMIN = 'accounting.admin'
export const SEARCH_ADMIN = 'search.admin'
export const FEEDBACK_ADMIN = 'feedback.admin'
export const INQUIRY_ADMIN = 'inquiry.admin'
export const SALES_ADMIN = 'sales.admin'
export const CUSTOMER_ADMIN = 'customer.admin'
export const STOCKLEVEL_import = 'commerce.stocklevel.import'
export const FACILITY_ADMIN = 'facility.admin'
export const INGEST_ADMIN = 'ingest.admin'
export const INGEST_ADMIN_EPARTS = 'ingest.admin.eparts'
export const INGEST_ADMIN_WEBPAGE = 'ingest.admin.webpage'
export const DOCUMENT_ADMIN = 'document.admin'
export const PRODUCT_ADMIN = 'product.admin'
export const KB_EQUIPMENT_READ = 'knowledge.equipment.read'
export const KB_EQUIPMENT_ADMIN = 'knowledge.equipment.admin'

export const SALES_ORDER_CUSTOMER = 'order.customer'
export const SALES_ORDER_SUBSIDIARY = 'order.subsidiary'
export const SALES_ORDER_HUB = 'order.hub'
export const SALES_ORDER_ADMIN = 'order.admin'

export const THING_TEMPLATE_ADMIN = 'thing-template.admin'
export const PRODUCTION_WEEK_import = 'production-week.admin'

export const PID_ADMIN = 'pid.admin'
export const PID_READ = 'pid.read'
export const PID_TRACE = 'pid.trace'

export const EQUIPMENT_ADMIN = 'equipment.admin'

export const ASSET_ADMIN = 'asset.admin'

export const ACTIVITY_READ = 'activity.read'
export const ACTIVITY_WRITE = 'activity.write'

export const PERMISSION_WISHLIST_WRITE = 'wishlist.write'
export const PERMISSION_WISHLIST_ADMIN = 'wishlist.admin'

export const PERMISSION_MANUFACTURING_READ = 'manufacturing.read'
export const PERMISSION_QUESTION_ASK = 'question.ask'

export const CLAIM_ADMIN = 'claim.admin'
export const CLAIM_SUBSIDIARY = 'claim.subsidiary'
export const CLAIM_REASON_ADMIN = 'claim-reason.admin'
export const CLAIM_WHITELIST_ADMIN = 'claim.whitelist.admin'
export const CONFIGURATION_ADMIN = 'config.admin'
export const KB_ADMIN = 'kb.admin'
export const SPARE_PART_ADMIN = 'sparepart.admin'
export const SPARE_PART_MAPPING_ADMIN = 'sparepart-mapping.admin'
export const SPARE_PART_REQUEST_ADMIN = 'sparepart.request.admin'

export const COMPANY_ENTITLEMENT_ADMIN = 'entitlement.company.admin'
export const AGENT_USE = 'agent.use'
export const AGENT_ADMIN = 'agent.admin'
export const ENVELOPE_ADMIN = 'envelope.admin'
export const CHINA_ADMIN = 'china.admin'
export const EXPORT_ADMIN = 'export.admin'
export const ORDER_REQUEST_READ = 'order.request.read'
export const ORDER_REQUEST_WRITE = 'order.request.write'
export const TRACE_ADMIN = 'trace.admin'
